import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { List, Input, Layout, Row, Col, Icon, Button, Select, Table } from 'antd'

import RightParametersPopup from '@components/Popup/RightParametersPopup'
import RightParamSetPopup from '@components/Popup/RightParamSetPopup'
import AddPolicyCollectionPopup from '@components/Popup/AddPolicyCollectionPopup'
import DeletePolicyCollectionPopup from '@components/Popup/DeletePolicyCollectionPopup'

import { policies } from '@services/api'
import Details from './Details'

@inject((store: any) => {
    const {
        authStore,
        parametersStore,
        rightsStore,
        rightsParametersStore,
        popupStore,
        paramGroupsStore,
        rightParamSetStore,
        policiesStore,
        policyCollectionsStore
    } = store
    return {
        authStore,
        parametersStore,
        rightsStore,
        rightsParametersStore,
        popupStore,
        paramGroupsStore,
        rightParamSetStore,
        policiesStore,
        policyCollectionsStore
    }
})
@observer
export default class Collections extends Component<any> {
    handleToggleDeleteCollection = async (name, id) => {
        const { policyCollectionsStore, popupStore, policy } = this.props
        await policyCollectionsStore.setCollection({ name: name, id: id })
        popupStore.togglePopup('deletePolicyCollection', { policy_id: policy.id, collection_id: id })
    }

    handleToggleAddCollection = async () => {
        const { policyCollectionsStore, popupStore, policy } = this.props
        popupStore.togglePopup('addPolicyCollection')
    }

    filterList = value => {
        const { policyCollectionsStore } = this.props
        policyCollectionsStore.filterList(value)
    }

    async componentDidMount() {
        await this.props.policyCollectionsStore.setPolicy(this.props.policy.name)
    }

    render() {
        const { policyCollectionsStore, policy } = this.props
        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                width: 75,
                align: 'right',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'שם הזכות',
                key: 'name',
                width: 1000,
                align: 'right',
                render: (_, record) => <Details {...record} /> //<span>{record.name}</span>
            },
            {
                title: '',
                key: '',
                align: 'right',
                width: 50,
                render: (_, record) => (
                    <div>
                        <Button onClick={() => this.handleToggleDeleteCollection(record.name, record.id)}>
                            <Icon type="delete" /> מחק קישור
                        </Button>
                    </div>
                )
            }
        ]
        return (
            <Layout style={{ padding: '1rem', backgroundColor: 'white' }}>
                <Row>
                    <Col xs={4}>
                        <Button style={{ width: '98%' }} onClick={() => this.handleToggleAddCollection()}>
                            <Icon type="plus" /> הוסף קישור
                        </Button>
                    </Col>
                    <Col xs={20}>
                        <Input.Search
                            placeholder="חיפוש על פי שם הזכות או מזהה"
                            onChange={e => this.filterList(e.target.value)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="box">
                            <Table
                                className="center-table"
                                style={{ width: '100%' }}
                                rowKey="id"
                                columns={columns}
                                dataSource={policyCollectionsStore.filteredList}
                            />
                        </div>
                    </Col>
                </Row>
                <AddPolicyCollectionPopup />
                <DeletePolicyCollectionPopup />
            </Layout>
        )
    }
}
